module.exports = __webpack_public_path__ + "img/ic_food_salad.cd6214ce.png";